// @ts-nocheck

import styled from 'styled-components';
import { GridItem } from '../../../../../../components/layout';

export const Wrapper = styled.footer.withConfig({ displayName: "styles__Wrapper", componentId: "sc-hqm4dy-0" })(["min-height:40px;border-top:1px solid #c0ccd7;display:flex;align-items:center;"]);






export const LeftSide = styled(GridItem).withConfig({ displayName: "styles__LeftSide", componentId: "sc-hqm4dy-1" })(["border-right:1px solid #c0ccd7;margin-right:10px;"]);
